/* eslint-disable */
import React, { PropTypes } from 'react';

class MensagemCadastradaIcon extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
        };

    }

    render() {

        return (

            <div><i className='icon-pencil'></i>
            </div>
        );
    }
}


export default MensagemCadastradaIcon;


// import React from 'react';
// import { blue500, red500, greenA200 } from 'material-ui/styles/colors';
// import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
// import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import getMuiTheme from 'material-ui/styles/getMuiTheme';
// import SvgIcon from 'material-ui/SvgIcon';

// const iconStyles = {
//     marginRight: 24,
// };

// const HomeIcon = (props) => (
//     <SvgIcon {...props}>
//         <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
//     </SvgIcon>
// );

// const Alarm = () => (
//     <div>
//         <MuiThemeProvider muiTheme={getMuiTheme(darkBaseTheme)}>
//             <SvgIcon style={iconStyles} color={greenA200} viewBox={'0 0 24 24'}  >
//                 <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
//             </SvgIcon>
//         </MuiThemeProvider>
//     </div>
// );


// export default Alarm;


/** WEBPACK FOOTER **
 ** ./src/components/iconesTimeLine/Alarm.js
 **/